import React from 'react'

const MoreInfo = props => (
  <svg width={16} height={16} {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <circle cx={8} cy={8} r={8} fill={props.fill} fillRule="nonzero" />
      <path
        fill="#fff"
        d="M10.286 11.92l-.14.572c-.419.165-.754.291-1.003.378-.25.087-.54.13-.87.13-.508 0-.902-.124-1.184-.371a1.203 1.203 0 01-.422-.943c0-.148.01-.3.031-.454a5.88 5.88 0 01.102-.524l.524-1.854c.047-.178.086-.346.118-.505.032-.158.048-.304.048-.434 0-.237-.049-.403-.147-.496-.097-.093-.284-.14-.56-.14-.135 0-.274.021-.416.063A6.117 6.117 0 006 7.463l.14-.572c.343-.14.671-.259.985-.358.314-.1.61-.15.89-.15.505 0 .893.122 1.166.366.274.243.41.56.41.949 0 .08-.009.223-.028.426-.019.203-.054.39-.105.558l-.522 1.847c-.042.149-.08.318-.114.51a2.557 2.557 0 00-.051.43c0 .246.055.413.164.502.11.089.3.134.57.134.128 0 .272-.023.432-.067a2.37 2.37 0 00.349-.117zm.132-7.752c0 .322-.121.596-.365.822-.243.227-.535.34-.878.34-.344 0-.637-.113-.883-.34a1.075 1.075 0 01-.369-.822c0-.321.123-.596.369-.825.245-.229.54-.343.883-.343.343 0 .635.115.878.343.244.229.365.504.365.825z"
      />
    </g>
  </svg>
)

export default MoreInfo
